import { render } from "./Time.vue?vue&type=template&id=949b88a4&scoped=true"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"

import "./Time.vue?vue&type=style&index=0&id=949b88a4&lang=scss&scoped=true"

import exportComponent from "E:\\xlckj\\大屏\\monitor\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-949b88a4"]])

export default __exports__